module.exports = __webpack_public_path__ + "img/renxingfuwu.2227f5a8.png";